import styled from 'styled-components';
import {getToken} from '@tickchak/react-share/app';
import {dFlexColumn} from '../../../../globalVariables/GlobalFlex';

export const footer = styled.div`
    ${dFlexColumn};
    gap: var(--space-md);
    width: 100%;
    padding: var(--space-sm) var(--space-lg) var(--space-lg);
    background: ${getToken('color.bg.surface.default')};
`;

export const divider = styled.div`
    width: 100%;
    height: 1px;
    background: ${getToken('color.border.subtle')};
`;
